import { useTranslation } from "react-i18next";

import { CUSTOM_CONFIRM_TYPES, CustomConfirm } from "components";
import { useDeleteKioskMutation } from "modules/KioskDashboard/components/DeleteKioskModal/hooks";

type DeleteKioskModalProps = {
  kioskId: number;
  resetDeleteKioskId: () => void;
};

export const DeleteKioskModal = ({ kioskId, resetDeleteKioskId }: DeleteKioskModalProps) => {
  const { t } = useTranslation();

  const { mutate: deleteKiosk, isPending: isDeleteKioskPending } = useDeleteKioskMutation();

  const handleDeleteKiosk = async () => {
    if (!kioskId) return;
    await deleteKiosk(kioskId);
    resetDeleteKioskId();
  };

  return (
    <CustomConfirm
      type={CUSTOM_CONFIRM_TYPES.Danger}
      isOpen={Boolean(kioskId)}
      handleCancel={resetDeleteKioskId}
      customTitle={t("v8_are_you_sure", "Are you sure?")}
      confirmMsg={t("v8_delete_confirm_message", "Are you sure that you want to delete this? You can't undo this action.")}
      handleConfirm={handleDeleteKiosk}
      isLoading={isDeleteKioskPending}
    />
  );
};
